import React from "react";
import Modal from "react-modal";
import moment from "moment";

const detailHeaderStyle = {
  padding: "16px 24px",
  borderBottom: "1px solid #e2e8f0",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: "#eff6ff",
};
const iconBoxStyle = {
  width: "40px",
  height: "40px",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#3B82F6",
};
const sectionHeaderStyle = {
  display: "flex",
  alignItems: "center",
  fontSize: "14px",
  marginBottom: "16px",
  gap: "8px",
};
const cardContainerStyle = {
  background: "#f8fafc",
  borderRadius: "16px",
  padding: "20px",
  border: "1px solid #f1f5f9",
};
const fieldLabelStyle = {
  fontSize: "12px",
  color: "#64748b",
  letterSpacing: "0.05em",
  marginBottom: "4px",
  display: "block",
};
const fieldValueWrapStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  color: "#111827",
  fontSize: "15px",
  fontWeight: "400",
};

// Función para obtener el estilo del badge según el tipo
const getTypeBadgeStyle = (tipo) => {
  const isProveedor = tipo?.toLowerCase() === "proveedor";
  return {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 12px",
    borderRadius: "9999px",
    fontSize: "0.875rem",
    fontWeight: "500",
    border: "1px solid",
    // Colores dinámicos: Púrpura para Proveedor, Azul para Cliente
    backgroundColor: isProveedor ? "#f3e8ff" : "rgb(219, 234, 254)",
    color: isProveedor ? "#7e22ce" : "rgb(29, 78, 216)",
    borderColor: isProveedor ? "#e9d5ff" : "rgb(191, 219, 254)",
  };
};

const parseFecha = (fecha) => {
  if (!fecha) return null;
  if (fecha.seconds) return new Date(fecha.seconds * 1000);
  const d = new Date(fecha);
  return isNaN(d.getTime()) ? null : d;
};

const ContactDetailModal = ({ isOpen, onClose, contact, modalStyles }) => {
  if (!contact) return null;

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyles}>
      {/* HEADER */}
      <div style={detailHeaderStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div style={iconBoxStyle}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </div>
          <div>
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "300",
                color: "#111827",
                margin: "0 0 4px 0",
              }}
            >
              Detalles del Contacto
            </h2>
            <p
              style={{
                fontSize: "15px",
                color: "#3B82F6",
                margin: 0,
                fontWeight: "500",
              }}
            >
              {contact.numeroRegistro || "C-000"}
            </p>
          </div>
        </div>
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#64748b"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      </div>

      {/* BODY */}
      <div
        style={{
          padding: "0 30px 30px 30px",
          display: "flex",
          flexDirection: "column",
          gap: "25px",
          maxHeight: "75vh",
          overflowY: "auto",
        }}
      >
        {/* SECCIÓN INFORMACIÓN GENERAL */}
        <div>
          <h4
            style={{
              ...sectionHeaderStyle,
              fontWeight: "500",
              color: "#64748b",
              fontSize: "13px",
              marginBottom: "12px",
              marginTop: "20px",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" x2="8" y1="13" y2="13" />
              <line x1="16" x2="8" y1="17" y2="17" />
              <line x1="10" x2="8" y1="9" y2="9" />
            </svg>
            Información General
          </h4>
          <div style={cardContainerStyle}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
              }}
            >
              <div>
                <span style={fieldLabelStyle}>Número de Registro</span>
                <div style={fieldValueWrapStyle}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#94a3b8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="4" x2="20" y1="9" y2="9"></line>
                    <line x1="4" x2="20" y1="15" y2="15"></line>
                    <line x1="10" x2="8" y1="3" y2="21"></line>
                    <line x1="16" x2="14" y1="3" y2="21"></line>
                  </svg>
                  {contact.numeroRegistro || "---"}
                </div>
                <div style={{ marginTop: "15px" }}>
                  <span style={fieldLabelStyle}>Razón Social</span>
                  <div style={fieldValueWrapStyle}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#94a3b8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect width="16" height="16" x="4" y="4" rx="2" />
                      <path d="M9 22v-10h6v10" />
                      <path d="M8 2v2" />
                      <path d="M12 2v2" />
                      <path d="M16 2v2" />
                    </svg>
                    {contact.empresa}
                  </div>
                </div>
              </div>
              <div>
                <span style={fieldLabelStyle}>Tipo</span>
                <div style={fieldValueWrapStyle}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#94a3b8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  <span style={getTypeBadgeStyle(contact.tipo)}>
                    {contact.tipo || "Cliente"}
                  </span>
                </div>
                <div style={{ marginTop: "15px" }}>
                  <span style={fieldLabelStyle}>RFC</span>
                  <div style={fieldValueWrapStyle}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#94a3b8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                      <line x1="2" x2="22" y1="10" y2="10"></line>
                    </svg>
                    {contact.rfc || "No especificado"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECCIÓN INFORMACIÓN DE CONTACTO */}
        <div>
          <h4
            style={{
              ...sectionHeaderStyle,
              fontWeight: "500",
              color: "#64748b",
              fontSize: "13px",
              marginBottom: "12px",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            Información de Contacto
          </h4>
          <div style={cardContainerStyle}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
              }}
            >
              <div>
                <span style={fieldLabelStyle}>Contacto</span>
                <div style={fieldValueWrapStyle}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#94a3b8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                  {contact.contactoPersonal || "---"}
                </div>
                <div style={{ marginTop: "15px" }}>
                  <span style={fieldLabelStyle}>Correo Electrónico</span>
                  <div style={fieldValueWrapStyle}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#94a3b8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                    </svg>
                    {contact.correo || "---"}
                  </div>
                </div>
              </div>
              <div>
                <span style={fieldLabelStyle}>Teléfono</span>
                <div style={fieldValueWrapStyle}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#94a3b8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  {contact.telefono || "---"}
                </div>
                <div style={{ marginTop: "15px" }}>
                  <span style={fieldLabelStyle}>Domicilio</span>
                  <div style={fieldValueWrapStyle}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#94a3b8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                      <circle cx="12" cy="10" r="3" />
                    </svg>
                    {contact.domicilio || "No especificado"}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECCIÓN INFORMACIÓN ADICIONAL */}
        <div>
          <h4
            style={{
              ...sectionHeaderStyle,
              fontWeight: "500",
              color: "#64748b",
              fontSize: "13px",
              marginBottom: "12px",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ marginRight: "8px" }}
            >
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
            </svg>
            Información Adicional
          </h4>
          <div style={cardContainerStyle}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
              }}
            >
              <div>
                <span style={fieldLabelStyle}>Fecha de Registro</span>
                <div style={fieldValueWrapStyle}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#94a3b8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      width="18"
                      height="18"
                      x="3"
                      y="4"
                      rx="2"
                      ry="2"
                    ></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                  {(() => {
                    const fecha = parseFecha(contact?.fechaRegistro);
                    return fecha
                      ? moment(fecha).format("DD/MM/YYYY, h:mm a")
                      : "Sin fecha";
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ContactDetailModal;
